import FiguresTooltip from '../FiguresTooltip';
import { Tooltip } from 'antd';

const Triangle = props => {
    const { research, scale, minDepth, width, title, date, toDepth } = props;

    const { leak_color, IsUpward, fluid_type } = research;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    if (IsUpward) {
        return (
            <Tooltip
                title={
                    <FiguresTooltip
                        title={title}
                        roof={roof}
                        bottom={bottom}
                        date={date}
                        inFlow={IsUpward}
                        fluid={fluid_type}
                    />
                }
                styles={{ minWidth: 'fit-content' }}
            >
                <svg
                    width={width}
                    height={(bottom - roof) * scale}
                    style={{
                        position: 'absolute',
                        left: 0,
                        transform: `translateY(${Math.abs((minDepth - roof - 1) * scale)}px)`,
                    }}
                >
                    <polygon
                    data-figure={IsUpward} points={`0,0 ${width},0 ${width / 2},${Math.abs((bottom - roof) * scale)}`} fill={leak_color} stroke={'#7E8DA9'} strokeWidth={1} />
                </svg>
            </Tooltip>
        );
    }
    return (
        <Tooltip
            title={
                <FiguresTooltip
                    title={title}
                    roof={roof}
                    bottom={bottom}
                    date={date}
                    inFlow={IsUpward}
                    fluid={fluid_type}
                />
            }
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg
                data-title={title}
                width={width}
                height={Math.abs((bottom - roof) * scale)}
                fill="none"
                style={{
                    position: 'absolute',
                    left: 0,
                    transform: `translateY(${Math.abs((minDepth - roof - 1) * scale)}px)`,
                }}
            >
                <polygon
                    data-bottom={bottom}
                    data-roof={roof}
                    data-scale={scale}
                    data-figure={IsUpward}
                    points={`${width / 2},0 0,${Math.abs((bottom - roof) * scale)} ${width},${Math.abs((bottom - roof) * scale)}`}
                    fill={leak_color}
                    stroke={'#7E8DA9'} strokeWidth={1}
                />
            </svg>
        </Tooltip>
    );
};

export default Triangle;
